<template>
<div class="numberer dark mx-1 custom-number-input text-sm md:text-base">
  <div class="flex flex-row w-full rounded-lg relative bg-transparent h-full">
    <button data-action="decrement"
            class="decr"
            @click='decrement'>
      <minus class="text-1xl text-base font-thin" />
    </button>

    <input type="text" @click='onClick' class="pbc-standard-input text-center" name="custom-input-number" v-bind:value="prettyNumber" @input="emitValue" />

    <button data-action="increment"
            class="incr"
            @click='increment'>

    <plus class="mg-auto text-1xl text-base font-thin" />

  </button>
  </div>
</div>
</template>
<script>
import Plus from '@icons/Plus.vue';
import Minus from '@icons/Minus.vue';
export default {
  props:{
    value:{
      type:Number,
      required:true
    },
    step:{
      type:Number,
      default:0.1
    }
  },
  methods:{
    onClick() {
      document.execCommand('selectall');
    },
    emitValue(event) {
      const num = parseFloat(event.target.value);
      if (!isNaN(num)) {
        this.$emit("input", num, this.value);
        this.$emit("change", num, this.value);
      } else {
        //this.$emit("input", parseFloat(event.target.value.replace(".", "").replace(",", "")));
      }
    },
    increment() {
      const nv = this.value + this.step;
      const ov = this.value;
      this.$emit("input", nv, ov);
      this.$emit("change", nv, ov);
    },
    decrement() {
      const nv = this.value - this.step;
      const ov = this.value;
      this.$emit("input", nv, ov);
      this.$emit("change", nv, ov);
    }
  },
  components:{
    Plus,
    Minus
  },
  computed:{
    prettyNumber() {
      return Number(this.value.toFixed(2).toString());
    }
  }
}
</script>
<style>
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .custom-number-input input:focus {
    outline: none !important;
  }

  .custom-number-input button:focus {
    outline: none !important;
  }

.decr:focus {
  @apply outline-none;
}
.incr:focus {
  @apply outline-none;
}

.numberer.dark .decr {
  @apply h-full p-0 m-0 border border-white text-white w-10 rounded-l cursor-pointer;
}
.numberer.dark .incr {
  @apply h-full p-0 m-0 border border-white text-white w-10 rounded-l cursor-pointer;
}
.numberer.dark:focus {
  @apply outline-none;
}

.numberer:focus {
  @apply outline-none;
}
.numberer.light:hover {
  @apply text-gray-700 bg-gray-400;
}

.numberer.light .decr {
  @apply h-full p-0 m-0 bg-gray-500 text-black w-10 rounded-l cursor-pointer;
}
.numberer.light .incr {
  @apply h-full p-0 m-0 bg-gray-500 text-black w-10 rounded-l cursor-pointer;
}
.numberer.light {
}
</style>

